import { useQuery } from '@tanstack/react-query';
import { downloadFile } from '@/services/files.service';

export const PHOTO_URL_QUERY_KEY = 'person-photo-url';

/**
 * Short-lived link for a person's photo (S3 key under `public/avatars/`).
 * The server signs links for 15 minutes, so a link is reused for 10 and then
 * asked for again; the same key on many rows costs one request.
 *
 * @param {string|null|undefined} photoKey
 * @returns {string|null} The link, or null while there is none.
 */
export default function usePhotoUrl(photoKey) {
  const { data } = useQuery({
    queryKey: [PHOTO_URL_QUERY_KEY, photoKey],
    queryFn: async () => (await downloadFile({ key: photoKey }))?.url || null,
    enabled: !!photoKey,
    staleTime: 10 * 60 * 1000,
    gcTime: 14 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });

  return photoKey ? data || null : null;
}
